module.exports = __webpack_public_path__ + "media/src/images/dandori/sample-ca76597538abc54330c161dae6457221.png";